const ukRegionInfo = {
  england: {
    fullName: 'England',
    code: 'eng',
    flagImage: '/englandFlag.png',
    tableName: 'england'
  },
  scotland: {
    fullName: 'Scotland',
    code: 'sct',
    flagImage: '/scotlandFlag.png',
    tableName: 'scotland'
  },
  wales: {
    fullName: 'Wales',
    code: 'wal',
    flagImage: '/walesFlag.png',
    tableName: 'wales'
  },
  northernireland: {
    fullName: 'Northern Ireland',
    code: 'ni',
    flagImage: '/northernIrelandFlag.png',
    tableName: 'northern_ireland'
  }
};

// Factory function to create UK region feeds
function createUKRegionFeeds(regionKey) {
  const region = ukRegionInfo[regionKey];
  if (!region) return null;

  switch (regionKey) {
    case 'england':
      return {
        legislative: [
          {
            id: 'eng-legislation',
            displayType: 'normal',
            name: 'England Legislation',
            apiParams: '&skip=0&schema=united_kingdom&table=uk_government_news&order_by=created_at&filter_column=collection_name&filter_string=England%20Legislation',
            feedBranch: 'Legislative',
            feedTopic: 'N/A',
            buttonName: 'Document',
          }
        ],
        executive: [
          {
            id: 'primeMinister',
            name: 'Prime Minister',
            displayType: 'normal',
            apiParams: '&skip=0&schema=united_kingdom&table=uk_government_news&order_by=created_at',
            feedBranch: 'Executive',
            feedTopic: 'N/A',
            buttonName: 'Document',
          }
        ],
        judicial: [
          {
            id: 'courts',
            name: 'Courts',
            displayType: 'normal',
            apiParams: '&skip=0&schema=united_kingdom&table=uk_government_news&order_by=created_at&filter_column=collection_name&filter_string=England%20Courts',
            feedBranch: 'Judicial',
            feedTopic: 'N/A',
            buttonName: 'Document',
          }
        ]
      };

    case 'scotland':
      return {
        legislative: [
          {
            id: 'si',
            name: 'Scotland Statutory Instruments',
            displayType: 'normal',
            apiParams: '&skip=0&schema=united_kingdom&table=uk_government_news&order_by=created_at&filter_column=collection_name&filter_string=Scotland%20Statutory%20Instruments',
            feedBranch: 'Legislative',
            feedTopic: 'N/A',
            buttonName: 'Document',
          }
        ],
        executive: [
          {
            id: 'scot-gov',
            name: 'Scottish Government',
            displayType: 'normal',
            apiParams: '&skip=0&schema=united_kingdom&table=uk_government_news&order_by=created_at&filter_column=collection_name&filter_string=Scottish%20Government',
            feedBranch: 'Executive',
            feedTopic: 'N/A',
            buttonName: 'Document',
          }
        ],
        judicial: [
          {
            id: 'scn',
            name: 'Scotland Courts News',
            displayType: 'normal',
            apiParams: '&skip=0&schema=united_kingdom&table=uk_government_news&order_by=created_at&filter_column=collection_name&filter_string=Scotland%20Courts%20News',
            feedBranch: 'Judicial',
            feedTopic: 'N/A',
            buttonName: 'Document',
          }
        ]
      };

    case 'wales':
      return {
        legislative: [
          {
            id: 'wales-leg',
            name: 'Wales Legislation',
            displayType: 'normal',
            apiParams: '&skip=0&schema=united_kingdom&table=uk_government_news&order_by=created_at&filter_column=collection_name&filter_string=Wales%20Legislation',
            feedBranch: 'Legislative',
            feedTopic: 'N/A',
            buttonName: 'Document',
          }
        ],
        executive: [
          {
            id: 'wales-gov',
            name: 'Welsh Government',
            displayType: 'normal',
            apiParams: '&skip=0&schema=united_kingdom&table=uk_government_news&order_by=created_at&filter_column=collection_name&filter_string=Welsh%20Government',
            feedBranch: 'Executive',
            feedTopic: 'N/A',
            buttonName: 'Document',
          }
        ],
        judicial: [
          {
            id: 'wjn',
            name: 'Wales Justice News',
            displayType: 'normal',
            apiParams: '&skip=0&schema=united_kingdom&table=uk_government_news&order_by=created_at&filter_column=collection_name&filter_string=Wales%20Justice%20News',
            feedBranch: 'Judicial',
            feedTopic: 'N/A',
            buttonName: 'Document',
          }
        ]
      };

    case 'northernireland':
      return {
        legislative: [
          {
            id: 'ni-leg',
            name: 'Northern Ireland Legislation',
            displayType: 'normal',
            apiParams: '&skip=0&schema=united_kingdom&table=uk_government_news&order_by=created_at&filter_column=collection_name&filter_string=Northern%20Ireland%20Legislation',
            feedBranch: 'Legislative',
            feedTopic: 'N/A',
            buttonName: 'Document',
          }
        ],
        executive: [
          {
            id: 'ni-exec',
            name: 'Northern Ireland Executive',
            displayType: 'normal',
            apiParams: '&skip=0&schema=united_kingdom&table=uk_government_news&order_by=created_at&filter_column=collection_name&filter_string=Northern%20Ireland%20Executive',
            feedBranch: 'Executive',
            feedTopic: 'N/A',
            buttonName: 'Document',
          }
        ],
        judicial: [
          {
            id: 'ni-courts',
            name: 'Northern Ireland Courts',
            displayType: 'normal',
            apiParams: '&skip=0&schema=united_kingdom&table=uk_government_news&order_by=created_at&filter_column=collection_name&filter_string=Northern%20Ireland%20Courts',
            feedBranch: 'Judicial',
            feedTopic: 'N/A',
            buttonName: 'Document',
          }
        ]
      };

    default:
      return {
        legislative: [],
        executive: [],
        judicial: [],
      };
  }
}

// Helper function to get UK region info
export const getUKRegionInfo = (regionKey) => ukRegionInfo[regionKey];

// Helper function to get UK region feeds by branch
export const getUKRegionFeedsByBranch = (regionKey, branch) => {
  const regionFeeds = createUKRegionFeeds(regionKey);
  if (!regionFeeds) return [];
  return regionFeeds[branch.toLowerCase()] || [];
};

// Get all UK regions
export const getAllUKRegions = () => Object.keys(ukRegionInfo);
export const unitedKingdomFeedsConfig = {

  // Schema-level recents: one feed that hits
  // https://api.govglance.org/posts/recent/schema?limit=<n>&skip=0&schema=united_kingdom
  // (no table -> useFeedData routes it to /posts/recent/schema). The limit is
  // driven by the maxItems each view requests.
  recent: [
    {
      id: 'recent-uk-0',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom',
      title: 'Recents',
      feedName: 'Recents',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/uk/recents',
      showOnHomePage: true
    }
  ],

  legislative: [
    {
      id: 'billUpdates',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=all_bills&order_by=created_at',
      title: 'Bill Updates',
      feedName: 'Bill Updates',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Doc',
      viewAllLink: '/uk/legislative',
      showOnHomePage: true
    },
    {
      id: 'lordsResearch',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=house_of_lords&order_by=created_at',
      title: 'House of Lords Research',
      feedName: 'House of Lords Research',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Doc',
      viewAllLink: '/uk/legislative',
      showOnHomePage: false
    }
  ],

  executive: [
    {
      id: 'no10',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=prime_minister&order_by=created_at',
      title: "Prime Minister's Office",
      feedName: "Prime Minister's Office",
      branch: 'Executive',
      topic: 'N/A',
      buttonName: 'Doc',
      viewAllLink: '/uk/prime-ministers-office',
      showOnHomePage: true
    },
    {
      id: 'ago',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Attorney%20Generals%20Office',
      title: "Attorney General's Office",
      feedName: "Attorney General's Office",
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/uk/attorney-generals-office',
      showOnHomePage: false
    },
    {
      id: 'dcms',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Culture%20Media%20And%20Sport',
      title: 'Department For Culture Media And Sport',
      feedName: 'Department For Culture Media And Sport',
      branch: 'Executive',
      topic: 'Culture',
      buttonName: 'Doc',
      viewAllLink: '/uk/culture-media-sport',
      showOnHomePage: false
    },
    {
      id: 'secretary-scotland',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Office%20Of%20The%20Secretary%20Of%20State%20For%20Scotland',
      title: 'Office Of The Secretary Of State For Scotland',
      feedName: 'Office Of The Secretary Of State For Scotland',
      branch: 'Executive',
      topic: 'Scottish Affairs',
      buttonName: 'Doc',
      viewAllLink: '/uk/secretary-of-state-scotland',
      showOnHomePage: false
    },
    {
      id: 'dsit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Science%20Innovation%20And%20Technology',
      title: 'Department For Science Innovation And Technology',
      feedName: 'Department For Science Innovation And Technology',
      branch: 'Executive',
      topic: 'Science & Tech',
      buttonName: 'Doc',
      viewAllLink: '/uk/department-for-science-innovation-and-technology',
      showOnHomePage: false
    },
    {
      id: 'cabinetOffice',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Cabinet%20Office',
      title: 'Cabinet Office',
      feedName: 'Cabinet Office',
      branch: 'Executive',
      topic: 'Government',
      buttonName: 'Doc',
      viewAllLink: '/uk/cabinet-office',
      showOnHomePage: false
    },
    {
      id: 'dft',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Transport',
      title: 'Department For Transport',
      feedName: 'Department For Transport',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/uk/department-for-transport',
      showOnHomePage: false
    },
    {
      id: 'fcdo',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Foreign%20Commonwealth%20Development%20Office',
      title: 'Foreign Commonwealth Development Office',
      feedName: 'Foreign Commonwealth Development Office',
      branch: 'Executive',
      topic: 'Foreign Affairs',
      buttonName: 'Doc',
      viewAllLink: '/uk/foreign-commonwealth-development-office',
      showOnHomePage: false
    },
    {
      id: 'home-office',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Home%20Office',
      title: 'Home Office',
      feedName: 'Home Office',
      branch: 'Executive',
      topic: 'Home Affairs',
      buttonName: 'Doc',
      viewAllLink: '/uk/home-office',
      showOnHomePage: false
    },
    {
      id: 'dfe',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Education',
      title: 'Department For Education',
      feedName: 'Department For Education',
      branch: 'Executive',
      topic: 'Education',
      buttonName: 'Doc',
      viewAllLink: '/uk/department-for-education',
      showOnHomePage: false
    },
    {
      id: 'mod',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Ministry%20Of%20Defence',
      title: 'Ministry Of Defence',
      feedName: 'Ministry Of Defence',
      branch: 'Executive',
      topic: 'Defense',
      buttonName: 'Doc',
      viewAllLink: '/uk/ministry-of-defence',
      showOnHomePage: false
    },
    {
      id: 'dbt',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Business%20And%20Trade',
      title: 'Department For Business And Trade',
      feedName: 'Department For Business And Trade',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/uk/department-for-business-and-trade',
      showOnHomePage: false
    },
    {
      id: 'leader-house-commons',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=The%20Office%20Of%20The%20Leader%20Of%20The%20House%20Of%20Commons',
      title: 'The Office Of The Leader Of The House Of Commons',
      feedName: 'The Office Of The Leader Of The House Of Commons',
      branch: 'Executive',
      topic: 'Government',
      buttonName: 'Doc',
      viewAllLink: '/uk/leader-house-commons',
      showOnHomePage: false
    },
    {
      id: 'leader-house-lords',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Office%20Of%20The%20Leader%20Of%20The%20House%20Of%20Lords',
      title: 'Office Of The Leader Of The House Of Lords',
      feedName: 'Office Of The Leader Of The House Of Lords',
      branch: 'Executive',
      topic: 'Lords',
      buttonName: 'Doc',
      viewAllLink: '/uk/leader-house-lords',
      showOnHomePage: false
    },
    {
      id: 'desnz',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Energy%20Security%20And%20Net%20Zero',
      title: 'Department For Energy Security And Net Zero',
      feedName: 'Department For Energy Security And Net Zero',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/uk/department-for-energy-security-and-net-zero',
      showOnHomePage: false
    },
    {
      id: 'defra',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Environment%20Food%20Rural%20Affairs',
      title: 'Department For Environment Food And Rural Affairs',
      feedName: 'Department For Environment Food And Rural Affairs',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/uk/department-for-environment',
      showOnHomePage: false
    },
    {
      id: 'dlu-hc',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Levelling%20Up%20Housing%20And%20Communities',
      title: 'Department For Levelling Up Housing And Communities',
      feedName: 'Department For Levelling Up Housing And Communities',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/uk/department-for-levelling-up-housing-and-communities',
      showOnHomePage: false
    },
    {
      id: 'dwp',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Work%20Pensions',
      title: 'Department For Work And Pensions',
      feedName: 'Department For Work And Pensions',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/uk/department-for-work-and-pensions',
      showOnHomePage: false
    },
    {
      id: 'dhsc',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20Of%20Health%20And%20Social%20Care',
      title: 'Department Of Health And Social Care',
      feedName: 'Department Of Health And Social Care',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/uk/department-of-health-and-social-care',
      showOnHomePage: false
    },
    {
      id: 'moj',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Ministry%20Of%20Justice',
      title: 'Ministry Of Justice',
      feedName: 'Ministry Of Justice',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/uk/ministry-of-justice',
      showOnHomePage: false
    },
    {
      id: 'nio',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Northern%20Ireland%20Office',
      title: 'Northern Ireland Office',
      feedName: 'Northern Ireland Office',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: 'Doc',
      viewAllLink: '/uk/northern-ireland-office',
      showOnHomePage: false
    },
    {
      id: 'wales',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Office%20Of%20The%20Secretary%20Of%20State%20For%20Wales',
      title: 'Office Of The Secretary Of State For Wales',
      feedName: 'Office Of The Secretary Of State For Wales',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: 'Doc',
      viewAllLink: '/uk/office-of-the-secretary-of-state-for-wales',
      showOnHomePage: false
    }
  ],

  judicial: [
    {
      id: 'supremeCourt',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=judicial&order_by=created_at',
      title: 'Supreme Court',
      feedName: 'Supreme Court',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Doc',
      viewAllLink: '/uk/judicial',
      showOnHomePage: true
    },
    {
      id: 'currentCases',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=current_cases&order_by=created_at',
      title: 'Current Cases',
      feedName: 'Current Cases',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Doc',
      viewAllLink: '/uk/judicial',
      showOnHomePage: false
    },
    {
      id: 'courtsTribunals',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=courts_and_tribunals&order_by=created_at',
      title: 'Courts and Tribunals',
      feedName: 'Courts and Tribunals',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Doc',
      viewAllLink: '/uk/judicial',
      showOnHomePage: false
    }
  ],

  defense: [
    {
      id: 'mod',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Ministry%20Of%20Defence',
      title: 'Ministry Of Defence',
      feedName: 'Ministry Of Defence',
      branch: 'Executive',
      topic: 'Defense',
      buttonName: 'Doc',
      viewAllLink: '/uk/defense',
      showOnHomePage: true
    }
  ],

  economy: [
    {
      id: 'dbt',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Business%20And%20Trade',
      title: 'Department For Business And Trade',
      feedName: 'Department For Business And Trade',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/uk/economy',
      showOnHomePage: false
    },
    {
      id: 'ukef',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=Uk%20export%20finance',
      title: 'UK Export Finance',
      feedName: 'UK Export Finance',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/uk/economy',
      showOnHomePage: false
    }
  ],

  environment: [
    {
      id: 'defra',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Environment%20Food%20Rural%20Affairs',
      title: 'Department For Environment Food And Rural Affairs',
      feedName: 'Department For Environment Food And Rural Affairs',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/uk/environment',
      showOnHomePage: true
    },
    {
      id: 'desnz',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Energy%20Security%20And%20Net%20Zero',
      title: 'Department For Energy Security And Net Zero',
      feedName: 'Department For Energy Security And Net Zero',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/uk/environment',
      showOnHomePage: false
    }
  ],

  foreignAffairs: [
    {
      id: 'fcdo',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Foreign%20Commonwealth%20Development%20Office',
      title: 'Foreign, Commonwealth & Development Office',
      feedName: 'Foreign, Commonwealth & Development Office',
      branch: 'Executive',
      topic: 'Foreign Affairs',
      buttonName: 'Doc',
      viewAllLink: '/uk/foreign-affairs',
      showOnHomePage: true
    },
    {
      id: 'mod-foreign',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Ministry%20Of%20Defence',
      title: 'Ministry of Defence',
      feedName: 'Ministry of Defence',
      branch: 'Executive',
      topic: 'Foreign Affairs',
      buttonName: 'Doc',
      viewAllLink: '/uk/foreign-affairs',
      showOnHomePage: false
    }
  ],

  health: [
    {
      id: 'dhsc',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20Of%20Health%20And%20Social%20Care',
      title: 'Department Of Health And Social Care',
      feedName: 'Department Of Health And Social Care',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/uk/health',
      showOnHomePage: true
    }
  ],

  infrastructure: [
    {
      id: 'dft',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Transport',
      title: 'Department For Transport',
      feedName: 'Department For Transport',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/uk/infrastructure',
      showOnHomePage: true
    },
    {
      id: 'desnz-infra',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Energy%20Security%20And%20Net%20Zero',
      title: 'Department For Energy Security And Net Zero',
      feedName: 'Department For Energy Security And Net Zero',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/uk/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'dlu-hc',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Levelling%20Up%20Housing%20And%20Communities',
      title: 'Department For Levelling Up Housing And Communities',
      feedName: 'Department For Levelling Up Housing And Communities',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/uk/infrastructure',
      showOnHomePage: false
    }
  ],

  justice: [
    {
      id: 'moj',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Ministry%20Of%20Justice',
      title: 'Ministry Of Justice',
      feedName: 'Ministry Of Justice',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/uk/justice',
      showOnHomePage: true
    },
    {
      id: 'ago-justice',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Attorney%20Generals%20Office',
      title: "Attorney General's Office",
      feedName: "Attorney General's Office",
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/uk/justice',
      showOnHomePage: false
    }
  ],

  science: [
    {
      id: 'dsit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Science%20Innovation%20And%20Technology',
      title: 'Department For Science Innovation And Technology',
      feedName: 'Department For Science Innovation And Technology',
      branch: 'Executive',
      topic: 'Science & Tech',
      buttonName: 'Doc',
      viewAllLink: '/uk/science&tech',
      showOnHomePage: true
    },
    {
      id: 'desnz-scitech',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Energy%20Security%20And%20Net%20Zero',
      title: 'Department for Energy Security & Net Zero',
      feedName: 'Department for Energy Security & Net Zero',
      branch: 'Executive',
      topic: 'Science & Tech',
      buttonName: 'Doc',
      viewAllLink: '/uk/science&tech',
      showOnHomePage: false
    }
  ],



};

// Helper functions
export const getFeedsByType = (sectionKey, type = 'normal') => {
  const sectionFeeds = unitedKingdomFeedsConfig[sectionKey] || [];
  return sectionFeeds.filter(feed => feed.type === type);
};

export const getNormalFeeds = (sectionKey) => {
  return getFeedsByType(sectionKey, 'normal');
};

export const getCarouselFeeds = (sectionKey) => {
  return getFeedsByType(sectionKey, 'carousel');
};